import React, { useEffect, useRef, useState } from "react";
import "../../styles.scss";
import profileImg from "../../assets/globalImgs/profile.png";
import "remixicon/fonts/remixicon.css"; // Import Remix Icon CSS
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useUser } from '../../utils/userContext';
import useHandleErrors from "../../utils/user.utils";
import Select from 'react-select';
import useConfiguration from '../../utils/ConfigurationContext';
import useCountryCodes from "../../utils/useCountryCodes";
import { Modal, Button } from "react-bootstrap";


export default function Onboardemployee() {
    const navigate = useNavigate();
    const { user } = useUser();
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleErrors = useHandleErrors();
    const config = useConfiguration();
    const [employess, setEmployess] = useState([]);
    const { countryCodes, currencySymbols } = useCountryCodes();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const hasFetched = useRef(false);
    const [countryOptions, setCountryOptions] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [agencies, setAgencies] = useState([]);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [paymentInfo, setPaymentInfo] = useState({
        PaymentType: "",
        Currency: "",
        Price: "",
        Tax: "",
        StartDate: "",
        EndDate: ""
    });

    const initialState = {
        EmployeeId: "",
        Title: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        PersonalEmail: "",
        OfficialEmail: "",
        ContactNumber: "",
        AlternateContactNumber: "",
        Department: "",
        Designation: "",
        UserAccessLevel: "",
        EmployeeType: "",
        ManagerEmail: "",
        Gender: "",
        BloodGroup: "",
        NID: "",
        DateOfBirth: "",
        DateOfJoining: "",
        DateOfLeaving: "",
        NoticePeriod: "",
        Religion: "",
        WorkLocation: "",
        BirthPlace: "",
        MaritalStatus: "",
        CitizenShip: "",
        NSSF: "",
        Tin: "",
        Image: "",
        SpouseOrChildren: "",
        Children: "0",
        Status: "Active",
        ActiveFlag: "Y",
        UpdatedBy: user?.FirstName ? user?.FirstName : "",
        DigitalSignature: "",
        presentAddress: {
            address1: "",
            address2: "",
            towncity: "",
            state: "",
            postcode: "",
            countrycode: "",
        },
        permanentAddress: {
            address1: "",
            address2: "",
            towncity: "",
            state: "",
            postcode: "",
            countrycode: "",
        },
        sameAsPresent: false,
    };
    const handleChildrenChange = (value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            Children: Math.max(0, prevFormData.Children + value),
        }));
    };

    const [formData, setFormData] = useState(initialState);
    const [errors, setErrors] = useState({
        dateError: "",
    });

    useEffect(() => {
        if (formData.EmployeeType === "Consultant") {
            axios.get(`${process.env.REACT_APP_BE_URL}/getpartnervendoronDetails`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => {
                    // Filter only agencies with UserType === "Vendor"
                    const vendors = (res.data.partnerVendorDetails || []).filter(
                        agency => agency.UserType === "Vendor"
                    );
                    setAgencies(vendors);
                })
                .catch(() => setAgencies([]));
        }
    }, [formData.EmployeeType, token]);

    console.log("agencies (vendors only):", agencies)

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployess();
            hasFetchedRef.current = true;
        }
    }, []);

    const fetchEmployess = async () => {
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setEmployess(response.data.onboardEmployeeDetails);
            }
            else {
                handleErrors(response)
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    useEffect(() => {
        if (hasFetched.current) return;

        hasFetched.current = true;

        axios.get('https://restcountries.com/v3.1/all?fields=name,cca2')
            .then(response => {
                const countries = response.data.map(country => ({
                    value: country.cca2,
                    label: country.name.common,
                }));
                setCountryOptions(countries);
            })
            .catch(error => {
                console.error('Error fetching countries:', error);
            });
    }, []);

    // Currency and country code options
    const currencyOptions = currencySymbols?.map((country, index) => ({
        value: `${country.value}-${index}`,
        label: `${country.value} (${country.label})`,
    })) || [];

    const countryCodeOptions = countryCodes?.map((country, index) => ({
        value: `${country.value}-${index}`,
        label: `${country.value} (${country.label})`,
    })) || [];

    //   image code start
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
                setSelectedImageFile(file);
                const reader = new FileReader();
                reader.onload = () => {
                    setImageSrc(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                toast.error('Only .jpg, .png, .jpeg files are allowed.', {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSelectedImageFile(null);
                setImageSrc('');
            }
        }
    };
    // end

    const handlePresentAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            presentAddress: {
                ...formData.presentAddress,
                [name]: value
            }
        });
    };

    const handlePermanentAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            permanentAddress: {
                ...formData.permanentAddress,
                [name]: value
            }
        });
    };

    const handleCheckboxChange = () => {
        setFormData((prevState) => ({
            ...prevState,
            sameAsPresent: !prevState.sameAsPresent,
            permanentAddress: prevState.sameAsPresent ? {
                address1: '',
                address2: '',
                towncity: '',
                state: '',
                postcode: '',
                countrycode: ''
            } : { ...prevState.presentAddress }
        }));
    };

    const handleReset = () => {
        setFormData(initialState);
        setSelectedImageFile("");
        setImageSrc(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let isValid = true;
        let isEmailValid = formData.isEmailValid;
        let isManagerEmail = formData.isManagerEmail;
        if (name === "OfficialEmail") {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            isEmailValid = emailPattern.test(value);
        }
        if (name === "ManagerEmail") {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            isManagerEmail = emailPattern.test(value);
        }

        if (name === "DateOfBirth") {
            const selectedDate = new Date(value);
            const today = new Date();
            const age = today.getFullYear() - selectedDate.getFullYear();
            const monthDifference = today.getMonth() - selectedDate.getMonth();
            const dayDifference = today.getDate() - selectedDate.getDate();

            if (
                age < 14 ||
                (age === 14 && monthDifference < 0) ||
                (age === 14 && monthDifference === 0 && dayDifference < 0)
            ) {
                isValid = false;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    DateOfBirth: "You must be at least 14 years old",
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    DateOfBirth: "",
                }));
            }
        }
        // Validation logic
        if (name === "DateOfJoining" && formData.DateOfLeaving) {
            if (new Date(value) > new Date(formData.DateOfLeaving)) {
                setErrors({
                    dateError: "Date of Joining must be less than Date of Leaving",
                });
            } else {
                setErrors({
                    dateError: "",
                });
            }
        }

        if (name === "DateOfLeaving" && formData.DateOfJoining) {
            if (new Date(value) < new Date(formData.DateOfJoining)) {
                setErrors({
                    dateError: "Date of Leaving must be greater than Date of Joining",
                });
            } else {
                setErrors({
                    dateError: "",
                });
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleKeyPress = (event) => {
        const charCode = event.charCode || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("No token found. Please login.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        // if (!selectedImageFile) {
        //     toast.error("Please Select Profile Image.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        if (!formData.EmployeeId) {
            toast.error("Employee Id is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.FirstName) {
            toast.error("First name is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Title) {
            toast.error("Title is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        if (!formData.LastName) {
            toast.error("Last name is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.UserAccessLevel) {
            toast.error("User Access is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.EmployeeType) {
            toast.error("Employment Type is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.OfficialEmail) {
            toast.error("Official Email is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        // Validate Country Code
        if (!formData.countryCode) {
            toast.error("Country Code is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        if (!formData.ContactNumber) {
            toast.error("Contact Number is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        const phoneNumberRegex = /^[0-9]{7,15}$/;

        if (!phoneNumberRegex.test(formData.ContactNumber)) {
            toast.error("Contact Number is invalid. Please enter a valid number.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        // if (formData.AlternateContactNumber && !phoneNumberRegex.test(formData.AlternateContactNumber)) {
        //     toast.error("Alternate Contact Number is invalid. Please enter a valid number.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        if (!formData.ManagerEmail) {
            toast.error("Manager Email is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Department) {
            toast.error("Department is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Designation) {
            toast.error("Designation is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.DateOfJoining) {
            toast.error("Date of Joining is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.DateOfJoining.match(dateRegex)) {
            toast.error("Invalid date format (DD-MM-YYYY required)", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (formData.DateOfLeaving && !formData.DateOfLeaving.match(dateRegex)) {
            toast.error("Invalid date format (DD-MM-YYYY required)", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Gender) {
            toast.error("Gender is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.PersonalEmail) {
            toast.error("Personal Email is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        // if (!formData.DateOfBirth) {
        //     toast.error("Date of Birth is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        // if (!formData.DateOfBirth.match(dateRegex)) {
        //     toast.error("Invalid date format (DD-MM-YYYY required)", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        // if (!formData.BloodGroup) {
        //     toast.error("Blood Group is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        // if (!formData.NID) {
        //     toast.error("NID is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        // if (!formData.Religion) {
        //     toast.error(" Religion is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        // if (!formData.MaritalStatus) {
        //     toast.error(" MaritalStatus is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }

        if (!formData.CitizenShip) {
            toast.error("Citizenship is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        // if (!formData.NSSF) {
        //     toast.error("NSSF is required.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     });
        //     setLoading(false);
        //     return;
        // }
        const fullEmployeeId = `${config?.employeePrefix || ""}${formData.EmployeeId}`;
        const fullContactNumber = `${formData.countryCode?.split('-')[0]} ${formData.ContactNumber}`;
        // const fullAlterContactNumber = `${formData.alternatecountryCode?.split('-')[0]} ${formData.AlternateContactNumber}`;
        const fullAlterContactNumber = formData.AlternateContactNumber
            ? `${formData.alternatecountryCode?.split('-')[0] || ''} ${formData.AlternateContactNumber}`.trim()
            : '';


        const { Image, DigitalSignature, presentAddress, permanentAddress, sameAsPresent, ...rest } = formData;

        // Main employee payload (jsonPayload)
        const jsonPayload = JSON.stringify({
            ...rest,
            EmployeeId: fullEmployeeId,
            ContactNumber: fullContactNumber,
            AlternateContactNumber: fullAlterContactNumber,
            AddressDetailsList: {
                CurrentAddress: [{
                    AddressOne: formData.presentAddress.address1,
                    AddressTwo: formData.presentAddress.address2,
                    TownCity: formData.presentAddress.towncity,
                    State: formData.presentAddress.state,
                    PostCode: formData.presentAddress.postcode,
                    CountryCode: formData.presentAddress.countrycode,
                }],
                PermanentAddress: [formData.sameAsPresent
                    ? {
                        AddressOne: formData.presentAddress.address1,
                        AddressTwo: formData.presentAddress.address2,
                        TownCity: formData.presentAddress.towncity,
                        State: formData.presentAddress.state,
                        PostCode: formData.presentAddress.postcode,
                        CountryCode: formData.presentAddress.countrycode,
                    }
                    : {
                        AddressOne: formData.permanentAddress.address1,
                        AddressTwo: formData.permanentAddress.address2,
                        TownCity: formData.permanentAddress.towncity,
                        State: formData.permanentAddress.state,
                        PostCode: formData.permanentAddress.postcode,
                        CountryCode: formData.permanentAddress.countrycode,
                    }
                ]
            }
        });

        // Consultant payload (consultantPayload) - only if Consultant
        let consultantPayload = null;
        if (formData.EmployeeType === "Consultant") {
            consultantPayload = JSON.stringify({
                EmployeeId: fullEmployeeId,
                AgencyName: selectedAgency,
                PaymentType: paymentInfo.PaymentType,
                Currency: paymentInfo.Currency?.split('-')[0] || "", // Extract currency code without index
                Price: paymentInfo.Price,
                Tax: paymentInfo.Tax,
                StartDate: paymentInfo.StartDate,
                EndDate: paymentInfo.EndDate
            });
        }

        const data = new FormData();
        data.append('Image', selectedImageFile);
        data.append('jsonPayload', jsonPayload);
        if (consultantPayload) {
            data.append('consultantPayload', consultantPayload);
        }

        try {
            const path = "/onboardEmployee";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 200) {
                toast.error("Employee onboarded successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                localStorage.setItem("EmployeeId", fullEmployeeId);
                localStorage.setItem("EmployeeName", formData.FirstName + " " + formData.MiddleName + " " + formData.LastName);
                localStorage.setItem("OfficialEmail", formData.OfficialEmail);
                localStorage.setItem("DateOfJoining", formData.DateOfJoining);
                navigate("/assignasset");
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
        finally {
            setLoading(false);
        }
    };

    const titleOptions = [
        // { value: "", label: "" },
        { value: "Mr", label: "Mr" },
        { value: "Mrs", label: "Mrs" },
        { value: "Miss", label: "Miss" },
        { value: "Ms", label: "Ms" },
        { value: "Dr", label: "Dr" },
    ];
    const bloodGroupOptions = [
        // { value: "", label: "" },
        { value: "A+", label: "A+" },
        { value: "A-", label: "A-" },
        { value: "B+", label: "B+" },
        { value: "B-", label: "B-" },
        { value: "AB+", label: "AB+" },
        { value: "AB-", label: "AB-" },
        { value: "O+", label: "O+" },
        { value: "O-", label: "O-" },
    ];
    const UserAccess = [
        // { value: "", label: "" },
        { value: "Admin", label: "Admin" },
        { value: "Super User", label: "Super User" },
        { value: "User", label: "User" },
    ];
    const EmployeeTypes = [
        // { value: "", label: "" },
        { value: "Contract", label: "Contract" },
        { value: "Permanent", label: "Permanent" },
        { value: "Expatriate", label: "Expatriate" },
        { value: "2MonthProbation", label: "3-Months Probation" },
        { value: "3MonthProbation", label: "6-Months Probation" },
        { value: "Consultant", label: "Consultant" },
    ];
  
    const employeeOptions = employess.map((emp) => ({
        value: emp.OfficialEmail,
        label: `${emp.OfficialEmail}`,
    }));

    const departmentOptions = config?.employeeManagement?.department?.map(department => ({
        value: department,
        label: department,
    }));
    const DesignationOptions = config?.employeeManagement?.designation?.map(designation => ({
        value: designation,
        label: designation,
    }));
    const religionOptions = config?.employeeManagement?.religion?.map(religion => ({
        value: religion,
        label: religion,
    }));

    // const tribeOptions = config?.employeeManagement?.tribe?.map(tribe => ({
    //     value: tribe,
    //     label: tribe,
    // }));

    // console.log("tribeOptions", tribeOptions);
    console.log("employeePrefix", config)

    const GenderOptions = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
        { value: "Not preferred to say", label: "Not preferred to say" },
    ];
    const maritialOptions = [
        { value: "Married", label: "Married" },
        { value: "Single", label: "Single" },
    ];
    // Custom component to hide the clear indicator
    const ClearIndicator = () => null;

    // Handle File Selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const handleDownloadTemplate = async () => {
        setDownloading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BE_URL}/employees/onboard-template`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob', // Important for file download
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Employee_Template.xlsx'); // Set file name
            document.body.appendChild(link);
            link.click();
            toast.success("Template downloaded successfully!", {
                position: toast.POSITION.TOP_CENTER,
            });
        } catch (error) {
            handleErrors(error.response);
        } finally {
            setDownloading(false); // end loading
        }
    };

    // Bulk Upload API
    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file to upload.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("UpdatedBy", user?.EmployeeId);

        setUploading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BE_URL}/employee/bulk-onboard`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                setShowModal(false)
                toast.success("File uploaded successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSelectedFile(null);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            handleErrors(error.response);
        } finally {
            setUploading(false);
        }
    };

    const handleFileReset = () => {
        setSelectedFile(null);
    };

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Onboard Employees</h3>
                        </div>
                        <div className="row mb-2">
                            <div className="col-auto">
                                {/* Download Template Button */}
                                <button
                                    className="btn btn-secondary"
                                    onClick={handleDownloadTemplate}
                                    disabled={downloading}
                                >
                                    {downloading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Downloading...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-file-download-line"></i> Download Employee Template
                                        </>
                                    )}
                                </button>
                            </div>
                            <div className="col-auto">
                                {/* Bulk Upload Button */}
                                <button
                                    className="btn btn-primary"
                                    onClick={() => setShowModal(true)}
                                    disabled={uploading}
                                >
                                    {uploading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Uploading...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-upload-cloud-2-line"></i> Upload Employee Data
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-1">
                            <div className="circle-tab-wrapper">
                                <ul className="nav nav-tabs circle-tab" role="tablist">
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            data-toggle="tab"
                                            title="Employee Information"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="ri-user-shared-line"></i>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            title="Assign Asset"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="ri-list-check-3"></i>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            title="Welcome Kit"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="ri-shapes-line"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <div className="col-lg-11">
                            <div className="tab-content">
                                <div
                                    className="tab-pane active"
                                    id="onbboard-employee-form"
                                    role="tabpanel"
                                >
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="card mb-4">
                                                    <div className="card-body">
                                                        <h5 className="title">Add New Employee</h5>
                                                        <div className="user-info">
                                                            <div className="profile-detail">
                                                                <div className="user-profile-pic">
                                                                    <img
                                                                        src={imageSrc ? imageSrc : profileImg}
                                                                        className="img-fluid"
                                                                        alt="Profile"
                                                                    />
                                                                </div>
                                                                <label
                                                                    htmlFor="file"
                                                                    className="profile-pic-upload"
                                                                    title="Upload Photo"
                                                                >
                                                                    <i className="ri-image-add-line"></i>
                                                                    <input
                                                                        onChange={handleImageChange}
                                                                        type="file"
                                                                        id="file"
                                                                        style={{ display: "none" }}
                                                                        name="image"
                                                                        accept="image/jpeg,image/jpg,image/png"
                                                                    />
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <small className="form-text text-muted text-center mt-3">
                                                            Only .jpg .png .jpeg allowed.
                                                        </small>
                                                        <div className="row mt-3">
                                                            <div className="form-group col-md-12">
                                                                <label
                                                                    htmlFor="EmployeeId"
                                                                    className="required"
                                                                >
                                                                    Employee ID
                                                                </label>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <div className="input-group-text">
                                                                            {config?.employeePrefix}
                                                                        </div>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="EmployeeId"
                                                                        value={formData.EmployeeId}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="title" className="required">
                                                                    First Name
                                                                </label>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <Select
                                                                            className="react-select-container"
                                                                            classNamePrefix="react-select"
                                                                            name="Title"
                                                                            value={
                                                                                titleOptions.find(
                                                                                    (option) =>
                                                                                        option.value === formData.Title
                                                                                ) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    Title: selectedOption
                                                                                        ? selectedOption.value
                                                                                        : "",
                                                                                })
                                                                            }
                                                                            options={titleOptions}
                                                                            components={{ ClearIndicator }}
                                                                            isClearable
                                                                            menuPortalTarget={document.body}
                                                                        />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="FirstName"
                                                                        value={formData.FirstName}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="middleName">Middle Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="MiddleName"
                                                                    value={formData.MiddleName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="lastName" className="required">
                                                                    Last Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="LastName"
                                                                    value={formData.LastName}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="userAccess"
                                                                    className="required"
                                                                >
                                                                    User Access
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="UserAccessLevel"
                                                                    value={
                                                                        UserAccess.find(
                                                                            (option) => option.value === formData.UserAccessLevel
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            UserAccessLevel: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={UserAccess}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="employeeType"
                                                                    className="required"
                                                                >
                                                                    Employment Type
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="EmployeeType"
                                                                    value={
                                                                        EmployeeTypes.find(
                                                                            (option) => option.value === formData.EmployeeType
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            EmployeeType: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={EmployeeTypes}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }), // Ensures top layer
                                                                        menu: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                            position: 'absolute',
                                                                            maxHeight: 'none',      // Optional: limit height
                                                                            overflowY: 'visible',       // Enables scrolling if needed
                                                                        }),
                                                                        control: base => ({ ...base, zIndex: 1 }),
                                                                    }}
                                                                    menuShouldScrollIntoView={true} // Ensures it auto scrolls into view
                                                                />
                                                            </div>
                                                            {formData.EmployeeType === "Consultant" && (
                                                                <div className="form-group col-md-12">
                                                                    <label htmlFor="agency" className="required">Select Vendor</label>
                                                                    <Select
                                                                        className="react-select-container"
                                                                        classNamePrefix="react-select"
                                                                        name="Agency"
                                                                        value={agencies.find(a => a.PartnerName === selectedAgency) ? { value: selectedAgency, label: selectedAgency } : null}
                                                                        onChange={opt => setSelectedAgency(opt ? opt.value : null)}
                                                                        options={agencies.map(a => ({ value: a.PartnerName, label: a.PartnerName }))}
                                                                        isClearable
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </div>
                                                            )}
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="email" className="required">
                                                                    Official Email
                                                                </label>
                                                                <input
                                                                    type="email"
                                                                    className={`form-control ${formData.isEmailValid === false
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                    name="OfficialEmail"
                                                                    value={formData.OfficialEmail}
                                                                    onChange={handleChange}
                                                                    required
                                                                />
                                                                {formData.isEmailValid === false && (
                                                                    <div className="invalid-feedback">
                                                                        Please enter a valid email address
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label
                                                                    htmlFor="contactNumber"
                                                                    className="required"
                                                                >
                                                                    Contact Number
                                                                </label>
                                                                {/* <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <Select
                                                                            className="react-select-container"
                                                                            classNamePrefix="react-select"
                                                                            name="countryCode"
                                                                            // value={
                                                                            //     countryCodesOptions.find(
                                                                            //         (option) => option.value === formData.countryCode
                                                                            //     ) || null
                                                                            // }
                                                                            value={
                                                                                countryCodeOptions.find(
                                                                                    (option) =>
                                                                                        option.value === formData.countryCode
                                                                                ) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    countryCode: selectedOption
                                                                                        ? selectedOption.value
                                                                                        : "",
                                                                                })
                                                                            }
                                                                            options={countryCodeOptions}
                                                                            components={{ ClearIndicator }}
                                                                            isClearable
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                control: base => ({ ...base, zIndex: 1 })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="contactNumber"
                                                                        name="ContactNumber"
                                                                        value={formData.ContactNumber}
                                                                        onChange={handleChange}
                                                                        onKeyPress={handleKeyPress}
                                                                        placeholder="Enter contact number"
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <button
                                                                            className="btn btn-secondary"
                                                                            title="Add Alternate Contact"
                                                                            type="button"
                                                                            data-toggle="collapse"
                                                                            data-target="#altContactNumber"
                                                                        >
                                                                            <i className="ri-add-circle-line"></i>
                                                                        </button>
                                                                    </div>
                                                                </div> */}
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend" style={{ maxWidth: '120px' }}>
                                                                        <Select
                                                                            className="react-select-container"
                                                                            classNamePrefix="react-select"
                                                                            name="countryCode"
                                                                            value={
                                                                                countryCodeOptions.find(
                                                                                    (option) => option.value === formData.countryCode
                                                                                ) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    countryCode: selectedOption ? selectedOption.value : '',
                                                                                })
                                                                            }
                                                                            options={countryCodeOptions}
                                                                            components={{ ClearIndicator }}
                                                                            isClearable
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                                control: (base) => ({
                                                                                    ...base,
                                                                                    zIndex: 1,
                                                                                    minHeight: '32px', // reduce height
                                                                                    fontSize: '0.85rem', // smaller text
                                                                                }),
                                                                                valueContainer: (base) => ({
                                                                                    ...base,
                                                                                    padding: '0 6px',
                                                                                }),
                                                                                indicatorsContainer: (base) => ({
                                                                                    ...base,
                                                                                    padding: '0 4px',
                                                                                }),
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="contactNumber"
                                                                        name="ContactNumber"
                                                                        value={formData.ContactNumber}
                                                                        onChange={handleChange}
                                                                        onKeyPress={handleKeyPress}
                                                                        placeholder="Enter contact number"
                                                                        style={{ minHeight: '32px', fontSize: '0.85rem' }} // match select size
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <button
                                                                            className="btn btn-secondary btn-sm" // smaller button
                                                                            title="Add Alternate Contact"
                                                                            type="button"
                                                                            data-toggle="collapse"
                                                                            data-target="#altContactNumber"
                                                                            style={{ minHeight: '7px', padding: '8px' }}
                                                                        >
                                                                            <i className="ri-add-circle-line"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>



                                                            </div>
                                                            <div
                                                                className="form-group col-md-12 collapse"
                                                                id="altContactNumber"
                                                            >
                                                                <label htmlFor="altContactNumber">
                                                                    Alternate Contact
                                                                </label>
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <Select
                                                                            className="react-select-container"
                                                                            classNamePrefix="react-select"
                                                                            name="alternatecountryCode"
                                                                            // value={
                                                                            //     countryCodesOptions.find(
                                                                            //         (option) => option.value === formData.alternatecountryCode
                                                                            //     ) || null
                                                                            // }
                                                                            value={
                                                                                countryCodeOptions.find(
                                                                                    (option) =>
                                                                                        option.value === formData.alternatecountryCode
                                                                                ) || null
                                                                            }
                                                                            onChange={(selectedOption) =>
                                                                                setFormData({
                                                                                    ...formData,
                                                                                    alternatecountryCode: selectedOption
                                                                                        ? selectedOption.value
                                                                                        : "",
                                                                                })
                                                                            }
                                                                            options={countryCodeOptions}
                                                                            components={{ ClearIndicator }}
                                                                            isClearable
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                control: base => ({ ...base, zIndex: 1 })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="contactNumber"
                                                                        name="AlternateContactNumber"
                                                                        value={formData.AlternateContactNumber}
                                                                        onChange={handleChange}
                                                                        onKeyPress={handleKeyPress}
                                                                        placeholder="Enter contact number"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="card mb-4">
                                                    <div className="card-body" id="addnewEmployeeDetails">
                                                        <h5
                                                            className="title accordion-title"
                                                            data-toggle="collapse"
                                                            data-target="#basicDetails"
                                                        >
                                                            Basic Information{" "}
                                                        </h5>
                                                        <div
                                                            className="row collapse show"
                                                            id="basicDetails"
                                                            data-parent="#addnewEmployeeDetails"
                                                        >

                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="ManagerEmail" className="required">
                                                                    Manager Email
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="ManagerEmail"
                                                                    value={
                                                                        employeeOptions.find(
                                                                            (option) => option.value === formData.ManagerEmail
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            ManagerEmail: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={employeeOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                                {formData.isManagerEmail === false && (
                                                                    <div className="invalid-feedback">
                                                                        Please enter a valid email address
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="department"
                                                                    className="required"
                                                                >
                                                                    Department
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="Department"
                                                                    value={
                                                                        departmentOptions?.find(
                                                                            (option) => option.value === formData.Department
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            Department: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={departmentOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="Designation"
                                                                    className="required"
                                                                >
                                                                    Designation
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="Designation"
                                                                    value={
                                                                        DesignationOptions?.find(
                                                                            (option) => option.value === formData.Designation
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            Designation: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={DesignationOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="sdate" className="required">
                                                                    Date of Joining
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    name="DateOfJoining"
                                                                    value={formData.DateOfJoining}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="edate">Date of Leaving</label>
                                                                <input
                                                                    type="date"
                                                                    className={`form-control ${errors.dateError && formData.DateOfLeaving ? 'is-invalid' : ''
                                                                        }`}
                                                                    name="DateOfLeaving"
                                                                    value={formData.DateOfLeaving}
                                                                    onChange={handleChange}
                                                                    required
                                                                />
                                                                {errors.dateError && <div className="invalid-feedback">{errors.dateError}</div>}
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="NoticePeriod">Notice Period</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control`}
                                                                    name="NoticePeriod"
                                                                    value={formData.NoticePeriod}
                                                                    onChange={handleChange}
                                                                    onKeyPress={handleKeyPress}
                                                                    required
                                                                />
                                                                {/* {errors.dateError && <div className="invalid-feedback">{errors.dateError}</div>} */}
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <h5
                                                            className="title accordion-title"
                                                            data-toggle="collapse"
                                                            data-target="#personalDetails"
                                                        >
                                                            Personal Information{" "}
                                                        </h5>
                                                        <div
                                                            className="row collapse show"
                                                            id="personalDetails"
                                                            data-parent="#addnewEmployeeDetails"
                                                        >
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="gender" className="required">
                                                                    Gender
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="Gender"
                                                                    value={
                                                                        GenderOptions.find(
                                                                            (option) => option.value === formData.Gender
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            Gender: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={GenderOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="pemail" className="required">Personal Email</label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="PersonalEmail"
                                                                    value={formData.PersonalEmail}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="jdate" >Date of Birth</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    name="DateOfBirth"
                                                                    value={formData.DateOfBirth}
                                                                    onChange={handleChange}
                                                                />
                                                                {errors.DateOfBirth && (
                                                                    <small className="text-danger">
                                                                        {errors.DateOfBirth}
                                                                    </small>
                                                                )}
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="bloodgroup" >
                                                                    Blood Group
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="BloodGroup"
                                                                    value={
                                                                        bloodGroupOptions.find(
                                                                            (option) => option.value === formData.BloodGroup
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            BloodGroup: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={bloodGroupOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="nid" >
                                                                    National ID
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="NID"
                                                                    value={formData.NID}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="religion" >
                                                                    Religion
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="Religion"
                                                                    value={
                                                                        religionOptions?.find(
                                                                            (option) => option.value === formData.Religion
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            Religion: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={religionOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            {/* <div className="form-group col-md-6">
                                                                <label htmlFor="tribe">
                                                                    Tribe
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="Tribe"
                                                                    value={formData.Tribe}
                                                                    onChange={handleChange}
                                                                />
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="Tribe"
                                                                    value={
                                                                        tribeOptions?.find(
                                                                            (option) => option.value === formData.Tribe
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            Tribe: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={tribeOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div> */}
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="WorkLocation">Work Location</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="WorkLocation"
                                                                    value={formData.WorkLocation}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="birthplace">Birth Place</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="BirthPlace"
                                                                    value={formData.BirthPlace}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="maritalstatus"

                                                                >
                                                                    Marital Status
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="MaritalStatus"
                                                                    value={
                                                                        maritialOptions.find(
                                                                            (option) => option.value === formData.MaritalStatus
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            MaritalStatus: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={maritialOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label
                                                                    htmlFor="citizenship"
                                                                    className="required"

                                                                >
                                                                    Citizenship
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="CitizenShip"

                                                                    value={
                                                                        countryOptions.find(
                                                                            (option) => option.label === formData.CitizenShip
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            CitizenShip: selectedOption ? selectedOption.label : "",
                                                                        })
                                                                    }
                                                                    options={countryOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: base => ({ ...base, zIndex: 1 })
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="NSSF" >
                                                                    National Social Security Fund
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="NSSF"
                                                                    value={formData.NSSF}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="tin">Tax Identification </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="Tin"
                                                                    value={formData.Tin}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            {formData.MaritalStatus === "Married" && (
                                                                <>
                                                                    <div className="form-group col-md-6">
                                                                        <label
                                                                            htmlFor="spousename"
                                                                            className="required"
                                                                        >
                                                                            Spouse Name
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="SpouseOrChildren"
                                                                            value={formData.SpouseOrChildren}
                                                                            onChange={handleChange}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-6">
                                                                        <label
                                                                            htmlFor="children"
                                                                            className="required"
                                                                        >
                                                                            Children
                                                                        </label>
                                                                        <div className="input-group">
                                                                            <div className="input-group-prepend">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-secondary"
                                                                                    onClick={() =>
                                                                                        handleChildrenChange(-1)
                                                                                    }
                                                                                    disabled={
                                                                                        formData.Children === 0 ||
                                                                                        formData.Children === "0"
                                                                                    }
                                                                                >
                                                                                    -
                                                                                </button>
                                                                            </div>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Children"
                                                                                value={formData.Children}
                                                                                onChange={handleChange}
                                                                                readOnly
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-secondary"
                                                                                    onClick={() =>
                                                                                        handleChildrenChange(1)
                                                                                    }
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                        <hr />
                                                        <h5
                                                            className="title accordion-title collapsed"
                                                            data-toggle="collapse"
                                                            data-target="#addressDetails"
                                                        >
                                                            Address Information{" "}
                                                        </h5>
                                                        <div className="row collapse" id="addressDetails" data-parent="#addnewEmployeeDetails">
                                                            <div className="col-lg-6 mt-4">
                                                                <h6>Present Address</h6>
                                                                <div className="row">

                                                                    {/* Present Address Fields */}
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="address1">Address Line 1</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="address1"
                                                                            value={formData.presentAddress.address1}
                                                                            onChange={handlePresentAddressChange}
                                                                            maxLength="40"
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="address2">Address Line 2</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="address2"
                                                                            value={formData.presentAddress.address2}
                                                                            onChange={handlePresentAddressChange}
                                                                            maxLength="40"
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="towncity">Town/City</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="towncity"
                                                                            value={formData.presentAddress.towncity}
                                                                            onChange={handlePresentAddressChange}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="state">State</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="state"
                                                                            value={formData.presentAddress.state}
                                                                            onChange={handlePresentAddressChange}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-6">
                                                                        <label htmlFor="permanentPostcode">Post Code</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="postcode"
                                                                            value={formData.presentAddress.postcode}
                                                                            onChange={handlePresentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-6">
                                                                        <label htmlFor="permanentCountrycode">Country Code</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="countrycode"
                                                                            value={formData.presentAddress.countrycode}
                                                                            onChange={handlePresentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="custom-control custom-checkbox">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id="sameaddress"
                                                                                checked={formData.sameAsPresent}
                                                                                onChange={handleCheckboxChange}
                                                                            />
                                                                            <label
                                                                                className="custom-control-label control-label-1"
                                                                                htmlFor="sameaddress"
                                                                            >
                                                                                Same as Present address
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <h6>Permanent Address</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    {/* Permanent Address Fields */}
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="permanentAddress1">Address Line 1</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="address1"
                                                                            value={formData.permanentAddress.address1}
                                                                            onChange={handlePermanentAddressChange}
                                                                            maxLength="40"
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="permanentAddress2">Address Line 2</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="address2"
                                                                            value={formData.permanentAddress.address2}
                                                                            onChange={handlePermanentAddressChange}
                                                                            maxLength="40"
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="permanentTownCity">Town/City</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="towncity"
                                                                            value={formData.permanentAddress.towncity}
                                                                            onChange={handlePermanentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-12">
                                                                        <label htmlFor="permanentState">State</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="state"
                                                                            value={formData.permanentAddress.state}
                                                                            onChange={handlePermanentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-6">
                                                                        <label htmlFor="permanentPostcode">Post Code</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="postcode"
                                                                            value={formData.permanentAddress.postcode}
                                                                            onChange={handlePermanentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                    <div className="form-group col-md-6">
                                                                        <label htmlFor="permanentCountrycode">Country Code</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="countrycode"
                                                                            value={formData.permanentAddress.countrycode}
                                                                            onChange={handlePermanentAddressChange}
                                                                            disabled={formData.sameAsPresent}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {formData.EmployeeType === "Consultant" && (
                                                            <>
                                                                <hr />
                                                                <h5
                                                                    className="title accordion-title collapsed"
                                                                    data-toggle="collapse"
                                                                    data-target="#paymentDetails"
                                                                >
                                                                    Payment Information{" "}
                                                                </h5>
                                                                <div className="row collapse" id="paymentDetails" data-parent="#addnewEmployeeDetails">
                                                                    <div className="card mb-4">
                                                                        <div className="card-body">
                                                                            <div className="row">
                                                                                <div className="form-group col-md-4">
                                                                                    <label className="required">Payment Type</label>
                                                                                    <Select
                                                                                        className="react-select-container"
                                                                                        classNamePrefix="react-select"
                                                                                        name="PaymentType"
                                                                                        value={
                                                                                            [
                                                                                                { value: "Hourly", label: "Hourly" },
                                                                                                { value: "Day rate", label: "Day rate" },
                                                                                                { value: "Fixed", label: "Fixed" }
                                                                                            ].find(option => option.value === paymentInfo.PaymentType) || null
                                                                                        }
                                                                                        onChange={selectedOption =>
                                                                                            setPaymentInfo({
                                                                                                ...paymentInfo,
                                                                                                PaymentType: selectedOption ? selectedOption.value : ""
                                                                                            })
                                                                                        }
                                                                                        options={[
                                                                                            { value: "Hourly", label: "Hourly" },
                                                                                            { value: "Day rate", label: "Day rate" },
                                                                                            { value: "Fixed", label: "Fixed" }
                                                                                        ]}
                                                                                        components={{ ClearIndicator }}
                                                                                        isClearable
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div className="form-group col-md-4">
                                                                                    <label className="required">Currency</label>
                                                                                    <Select
                                                                                        className="react-select-container"
                                                                                        classNamePrefix="react-select"
                                                                                        name="Currency"
                                                                                        value={
                                                                                            currencyOptions.find(
                                                                                                (option) =>
                                                                                                    option.value === paymentInfo.Currency
                                                                                            ) || null
                                                                                        }
                                                                                        onChange={(selectedOption) =>
                                                                                            setPaymentInfo({
                                                                                                ...paymentInfo,
                                                                                                Currency: selectedOption ? selectedOption.value : "",
                                                                                            })
                                                                                        }
                                                                                        options={currencyOptions}
                                                                                        components={{ ClearIndicator }}
                                                                                        isClearable
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div className="form-group col-md-4">
                                                                                    <label className="required">Price</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        value={paymentInfo.Price}
                                                                                        min="0" //  no negative values
                                                                                        onChange={e => setPaymentInfo({
                                                                                            ...paymentInfo,
                                                                                            Price: e.target.value
                                                                                        })}
                                                                                        required
                                                                                    />
                                                                                </div>

                                                                                <div className="form-group col-md-4">
                                                                                    <label className="required">Tax%</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={paymentInfo.Tax}
                                                                                        onChange={e => setPaymentInfo({ ...paymentInfo, Tax: e.target.value })}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center ONBfirstTab">
                    <button className="btn btn-light" type="reset" onClick={handleReset}>
                        Reset
                    </button>
                    <button
                        className="btn btn-primary btnNext"
                        type="button"
                        onClick={handleSubmit}
                    >
                        Next <i className="ri-arrow-right-circle-line"></i>
                    </button>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Document</Modal.Title>
                </Modal.Header>
                <div className="alert alert-info" role="alert">
                    <i className="ri-information-line"></i> Please download the template, enter employee details, and upload the completed file.
                </div>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="Document">Select File</label>
                        <div className="custom-file">
                            <input
                                type="file"
                                className="custom-file-input"
                                id="Document"
                                onChange={handleFileChange}
                            />
                            <label className="custom-file-label" htmlFor="Document">
                                {selectedFile ? selectedFile.name : "Choose a file"}
                            </label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center py-2">
                    <Button variant="warning" onClick={handleFileReset}>
                        Reset
                    </Button>
                    <Button variant="success" onClick={handleUpload} disabled={!selectedFile}>
                        <i className="ri-upload-cloud-2-line"></i> Upload
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>

    );
}
